import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Heart } from 'lucide-react';
import { Button } from '../ui/Button';
import { cn } from '../../lib/utils';
import { useLanguage } from '../../context/LanguageContext';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const {
    t,
    isRTL
  } = useLanguage();
  const location = useLocation();
  const navigation = [{
    name: t('nav.home'),
    href: '/'
  }, {
    name: t('nav.about'),
    href: '/about'
  }, {
    name: t('nav.membership'),
    href: '/membership'
  }, {
    name: t('nav.events'),
    href: '/events'
  }, {
    name: t('nav.charity'),
    href: '/charity'
  }, {
    name: t('nav.team'),
    href: '/team'
  }, {
    name: t('nav.contact'),
    href: '/contact'
  }];
  const isActive = (path: string) => {
    if (path === '/' && location.pathname !== '/') return false;
    return location.pathname.startsWith(path);
  };
  return <header className="sticky top-0 z-50 w-full border-b border-gray-100 bg-white/95 backdrop-blur supports-[backdrop-filter]:bg-white/60" data-id="element-64">
      <div className="container mx-auto px-4 md:px-6" data-id="element-65">
        <div className="flex h-20 items-center justify-between" data-id="element-66">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3" data-id="element-67">
            <img src="https://cdn.magicpatterns.com/uploads/aA4YJyXsgBXST459kH7g7H/New_Logo_bg_remove.png" alt="Khyber Medical Association UK Logo" className="h-16 w-16 object-contain" data-id="element-68" />
            <div className="flex flex-col" data-id="element-69">
              <span className="text-lg font-serif font-bold leading-none text-primary-900" data-id="element-70">
                KMA UK
              </span>
              <span className="text-xs text-gray-500" data-id="element-71">
                Khyber Medical Association
              </span>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden xl:flex items-center space-x-6" data-id="element-72">
            {navigation.map(item => <Link key={item.href} to={item.href} className={cn('text-sm font-medium transition-colors hover:text-primary-700', isActive(item.href) ? 'text-primary-700 font-semibold' : 'text-gray-600')} data-id="element-73">
                {item.name}
              </Link>)}

            <div className="flex items-center gap-3 ml-4" data-id="element-74">
              <Link to="/membership" data-id="element-75">
                <Button size="sm" variant="primary" data-id="element-76">
                  {t('nav.joinMembership')}
                </Button>
              </Link>
              <a href="https://donate.stripe.com/test_kmauk_placeholder" target="_blank" rel="noopener noreferrer" data-id="element-77">
                <Button size="sm" variant="secondary" data-id="element-78">
                  <Heart className={cn('h-4 w-4', isRTL ? 'ml-2' : 'mr-2')} data-id="element-79" />
                  {t('nav.donate')}
                </Button>
              </a>
            </div>
          </nav>

          {/* Mobile Menu Button */}
          <button className="xl:hidden p-2 text-gray-600" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-80">
            {isMenuOpen ? <X className="h-6 w-6" data-id="element-81" /> : <Menu className="h-6 w-6" data-id="element-82" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isMenuOpen && <div className="xl:hidden border-t border-gray-100 bg-white max-h-[calc(100vh-5rem)] overflow-y-auto" data-id="element-83">
          <div className="container mx-auto px-4 py-4 space-y-4" data-id="element-84">
            {navigation.map(item => <Link key={item.href} to={item.href} className={cn('block text-base font-medium py-2', isActive(item.href) ? 'text-primary-700' : 'text-gray-600')} onClick={() => setIsMenuOpen(false)} data-id="element-85">
                {item.name}
              </Link>)}

            <div className="pt-4 space-y-3 border-t border-gray-100" data-id="element-86">
              <Link to="/membership" onClick={() => setIsMenuOpen(false)} data-id="element-87">
                <Button className="w-full" data-id="element-88">{t('nav.joinMembership')}</Button>
              </Link>
              <a href="https://donate.stripe.com/test_kmauk_placeholder" target="_blank" rel="noopener noreferrer" className="block" data-id="element-89">
                <Button variant="secondary" className="w-full" data-id="element-90">
                  <Heart className={cn('h-4 w-4', isRTL ? 'ml-2' : 'mr-2')} data-id="element-91" />
                  {t('nav.donate')}
                </Button>
              </a>
            </div>
          </div>
        </div>}
    </header>;
}